import { capitalize } from 'lodash';
import { Card, CardContent } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { generateBackdropStyles } from '@client/theme/components/Card';
import type { ButtonProps } from '@mui/material';

const useStyles = makeStyles({ name: 'Backdrop' })((theme) => ({
  radiusSmall: {
    borderRadius: theme.radii.small,
  },
  radiusMedium: {
    borderRadius: theme.radii.medium,
  },
  radiusLarge: {
    borderRadius: theme.radii.large,
  },
  ...generateBackdropStyles(theme),
}));

interface InlineBackdropProps {
  readonly children: React.ReactNode;
  readonly color?: ButtonProps['color'];
  readonly radius?: 'small' | 'medium' | 'large';
  readonly className?: string;
}

export const InlineBackdrop: React.FC<InlineBackdropProps> = ({
  children, color, radius = 'large', className = '',
}) => {
  const { classes, cx } = useStyles();

  return (
    <Card
      className={cx(classes[`color${capitalize(color)}`], classes[`radius${capitalize(radius)}`], className)}
    >
      <CardContent>
        {children}
      </CardContent>
    </Card>
  );
};
